export const AgentViewTypes = {
  DEFAULT: "DEFAULT",
  TRANSFER: "TRANSFER",
};

export const AgentTabView = {
  AGENT_CHAT: "AGENT_CHAT",
  REQUEST_CALLBACK: "REQUEST_CALLBACK",
  RAISE_QUERY: "RAISE_QUERY",
};

export const AgentStatusView = {
  READY: "READY",
  NOT_READY: "NOT_READY",
};

export const MessagesTab = {
  CANNED_MESSAGES: "CANNED_MESSAGES",
  SUGGESTIONS: "SUGGESTIONS",
  DEALER_LOCATIONS: "DEALER_LOCATIONS"
};
